export default "__VITE_ASSET__CPfSwGq8__"